module.exports = __webpack_public_path__ + "img/overwhelming firepower.654fb4fe.png";